import Vue from "vue";
import Router from "vue-router";

import { authGuard } from "./authGuard";
import { telemetryEnterGuard, telemetryLeaveGuard } from "./telemetryGuard";
import Home from "@/views/Home/Home.vue";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: "",
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
        },
        {
            path: "/login",
            name: "login",
            component: () => import(/* webpackChunkName: "login" */ "@/views/Login/Login.vue"),
            meta: {
                anonymous: true,
            },
        },
        {
            path: "/supply",
            component: () => import(/* webpackChunkName: "supply" */ "@/views/Supply/Supply.vue"),
            children: [
                {
                    path: "",
                    name: "supply",
                    component: () => import(/*webpackChunkName: "supplyIndex" */ "@/views/Supply/SupplyIndex.vue"),
                },
                {
                    path: "productionline/:productionLineId",
                    name: "supplyProductionLine",
                    component: () => import(/* webpackChunkName: "supplyProductionLine" */ "@/views/Supply/SupplyProductionLine.vue"),
                },
                {
                    path: "workorder/:workOrderId",
                    name: "supplyWorkOrder",
                    component: () => import(/* webpackChunkName: "supplyWorkOrder" */ "@/views/Supply/SupplyWorkOrder.vue"),
                },
                {
                    path: "component/:workOrderComponentId",
                    name: "supplyComponent",
                    component: () => import(/* webpackChunkName: "supplyComponent" */ "@/views/Supply/SupplyComponent.vue"),
                },
            ],
            meta: {
                production: true,
            },
        },
        {
            path: "/return",
            component: () => import(/* webpackChunkName: "return" */ "@/views/Return/Return.vue"),
            children: [
                {
                    path: "",
                    name: "return",
                    component: () => import(/*webpackChunkName: "returnIndex" */ "@/views/Return/ReturnIndex.vue"),
                },
                {
                    path: "productionline/:productionLineId",
                    name: "returnProductionLine",
                    component: () => import(/*webpackChunkName: "returnProductionLine" */ "@/views/Return/ReturnProductionLine.vue"),
                },
                {
                    path: "workorder/:workOrderId",
                    name: "returnWorkOrder",
                    component: () => import(/*webpackChunkName: "returnWorkOrder" */ "@/views/Return/ReturnWorkOrder.vue"),
                },
                {
                    path: "component/:workOrderComponentId",
                    name: "returnComponent",
                    component: () => import(/* webpackChunkName: "returnComponent" */ "@/views/Return/ReturnComponent.vue"),
                },
                {
                    path: "detail/:workOrderComponentId",
                    name: "returnDetail",
                    component: () => import(/* webpackChunkName: "returnComponent" */ "@/views/Return/ReturnDetail.vue"),
                },
            ],
            meta: {
                production: true,
            },
        },
        {
            path: "/machinist",
            component: () => import(/* webpackChunkName: "Machinist" */ "@/views/Machinist/Machinist.vue"),
            children: [
                {
                    path: "",
                    name: "machinist",
                    component: () => import(/* webpackChunkName: "machinistWorkOrders" */ "@/views/Machinist/MachinistIndex.vue"),
                },
                {
                    path: "productionline/:productionLineId",
                    name: "machinistProductionLine",
                    component: () => import(/* webpackChunkName: "machinistProductionLine" */ "@/views/Machinist/MachinistProductionLine.vue"),
                },
                {
                    path: "workorder/:workOrderId",
                    name: "machinistWorkOrder",
                    component: () => import(/* webpackChunkName: "machinistWorkOrder" */ "@/views/Machinist/MachinistWorkOrder.vue"),
                },
                {
                    path: "component/:workOrderComponentId",
                    name: "machinistComponent",
                    component: () => import(/* webpackChunkName: "machinistComponent" */ "@/views/Machinist/MachinistComponent.vue"),
                },
                {
                    path: "supply/:workOrderComponentId",
                    name: "machinistSupply",
                    component: () => import(/* webpackChunkName: "machinistSupply" */ "@/views/Machinist/MachinistSupply.vue"),
                },
            ],
            meta: {
                machinist: true,
            },
        },
        {
            path: "/reception",
            component: () => import(/* webpackChunkName: "Reception" */ "@/views/Reception/Reception.vue"),
            children: [
                {
                    path: "",
                    name: "reception",
                    component: () => import(/* webpackChunkName: "ReceptionIndex" */ "@/views/Reception/ReceptionIndex.vue"),
                },
                {
                    path: "create",
                    name: "receptionCreate",
                    component: () => import(/* webpackChunkName: "ReceptionNew" */ "@/views/Reception/ReceptionNew.vue"),
                },
                {
                    path: "detail",
                    name: "receptionDetail",
                    component: () => import(/* webpackChunkname: "ReceptionDelivery" */ "@/components/Reception/ReceptionDelivery.vue"),
                },
                {
                    path: "validation",
                    name: "receptionValidation",
                    component: () => import(/* webpackChunkName: "ReceptionValidation" */ "@/views/Reception/ReceptionValidation.vue"),
                },
            ],
            meta: {
                reception: true,
            },
        },
        {
            path: "/security",
            component: () => import(/* webpackChunkName: "Security" */ "@/views/Security/Security.vue"),
            children: [
                {
                    path: "",
                    name: "security",
                    component: () => import(/* webpackChunkName: "SecurityIndex" */ "@/views/Security/SecurityIndex.vue"),
                },
                {
                    path: "appointment",
                    name: "securityAppointment",
                    component: () => import(/* webpackChunkName: "SecurityAppointment" */ "@/views/Security/SecurityAppointment.vue"),
                },
                {
                    path: "detail",
                    name: "securityAppointmentDetail",
                    component: () => import(/* webpackChunkName: "SecurityDetail" */ "@/components/Security/SecurityDetail.vue"),
                },
            ],
            meta: {
                security: true,
            },
        },
        {
            path: "/stockage",
            component: () => import(/* webpackChunkName: "Security" */ "@/views/Stockage/Stockage.vue"),
            children: [
                {
                    path: "",
                    name: "stockage",
                    component: () => import(/* webpackChunkName : "StockageIndex */ "@/views/Stockage/StockageIndex.vue"),
                },
                {
                    path: "productionLine/:productionLineId",
                    name: "stockageProductionLine",
                    component: () => import(/* webpackChunkName: "stockageProductionLine" */ "@/views/Stockage/StockageProductionLine.vue"),
                },
                {
                    path: "search",
                    name: "stockageSearch",
                    component: () => import(/* webpackChunkName: "StockageSearch" */ "@/views/Stockage/StockageSearch.vue"),
                },
                {
                    path: "cleaning",
                    name: "stockageCleaning",
                    component: () => import(/* webpackChunkName: "stockageCleaning" */ "@/views/Stockage/StockageCleaning.vue"),
                },
            ],
            meta: {
                storage: true,
            },
        },
        {
            path: "/outofline",
            component: () => import(/* webpackChunkName: "OutOfLine" */ "@/views/OutOfLine/OutOfLine.vue"),
            children: [
                {
                    path: "",
                    name: "outOfLine",
                    component: () => import(/* webpackChunkname: "OutOfLineIndex" */ "@/views/OutOfLine/OutOfLineIndex.vue"),
                },
                {
                    path: "productionline/:productionLineId",
                    name: "outOfLineProductionLine",
                    component: () => import(/* webpackChunkName: "outOfLineProductionLine" */ "@/views/OutOfLine/OutOfLineProductionLine.vue"),
                },
                {
                    path: "cleaning",
                    name: "outOfLineCleaning",
                    component: () => import(/* webpackChunkName: "outOfLineCleaning" */ "@/views/OutOfLine/OutOfLineCleaning.vue"),
                },
                {
                    path: "countpallets",
                    name: "outOfLineCountPallets",
                    component: () => import(/* webpackChunkName: "outOfLineCountPallets" */ "@/views/OutOfLine/OutOfLineCountPallets.vue"),
                },
                {
                    path: "countconsumables",
                    name: "outOfLineCountConsumables",
                    component: () => import(/* webpackChunkName: "outOfLineCountConsumables" */ "@/views/OutOfLine/OutOfLineCountConsumables.vue"),
                },
            ],
            meta: {
                outOfLine: true,
            },
        },
        {
            path: "/notes",
            component: () => import(/* webpackChunkName: "Notes" */ "@/views/Notes/Notes.vue"),
            children: [
                {
                    path: "",
                    name: "notes",
                    component: () => import(/* webpackChunkName: "NotesIndex" */ "@/views/Notes/NotesIndex.vue"),
                },
                {
                    path: ":saleOrderId",
                    name: "notesDetail",
                    component: () => import(/* webpackChukName: "NotesDetail" */ "@/views/Notes/NotesDetail.vue"),
                },
            ],
            meta: {
                saleOrder: true,
            },
        },
        {
            path: "/expedition",
            component: () => import(/* webpackChunkName: "Expedition" */ "@/views/Expedition/Expedition.vue"),
            children: [
                {
                    path: "",
                    name: "expedition",
                    component: () => import(/* webpackChunkName: "ExpeditionIndex" */ "@/views/Expedition/ExpeditionIndex.vue"),
                },
                {
                    path: "transporters",
                    name: "ManageTransporters",
                    component: () => import(/* webpackChunkName: "ManageTransporters" */ "@/views/Expedition/ManageTransporters.vue"),
                    meta: {
                        manageExpedition: true,
                    },
                },
            ],
            meta: {
                expedition: true,
            },
        },
        {
            path: "/expedition/create",
            name: "ExpeditionCreate",
            component: () => import(/* webpackChunkName: "ExpeditionCardCreate" */ "@/views/Expedition/ExpeditionCreate.vue"),
            meta: {
                expedition: true,
            },
        },
        {
            path: "/expedition/card",
            name: "ExpeditionCard",
            component: () => import(/* webpackChunkName: "ExpeditionCard" */ "@/views/Expedition/ExpeditionCard.vue"),
            meta: {
                expedition: true,
            },
        },
        {
            path: "/auth",
            redirect: "/",
            meta: {
                anonymous: true,
            },
        },
        {
            path: "*",
            redirect: "/",
        },
    ],
});

router.beforeEach(authGuard);

router.beforeEach(telemetryEnterGuard);
router.afterEach(telemetryLeaveGuard);

export { router };
